var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from '../../components';
import { renderIcon } from '../../utils';
import * as styles from './fad-button.styles';
var FADButton = function (_a) {
    var title = _a.title, icon = _a.icon, type = _a.type, click = _a.click, textToggle = _a.textToggle, iconDirection = _a.iconDirection, size = _a.size, props = __rest(_a, ["title", "icon", "type", "click", "textToggle", "iconDirection", "size"]);
    return (_jsxs(Button, __assign({ type: type, size: size ? size : textToggle ? 'large' : 'large-round', onClick: click }, props, { children: [iconDirection === 'left' && renderIcon(icon, styles.icon), textToggle && (_jsx(Typography, { className: styles.text, type: "body", fontSize: size === 'small' ? '14' : '16', weight: "bold", color: type === 'ghost' ? props.color : 'white', text: title })), iconDirection === 'right' && renderIcon(icon, styles.icon)] })));
};
export { FADButton };
//# sourceMappingURL=fad-button.js.map